import "../styles/getGold.css";
import { PlayerProfile, UpgradeTarget, nextUpgradeLevel } from "@highmarch/domain";
import { fmtCompact } from "../kit";
import { openShops } from "../shops/shopsScreen";
import { SUPPLIES_TAB } from "../shops/shopsModel";
import { confirmPurchase } from "./purchaseFx";
import { gemIcon, goldIcon } from "./econArt";
import { openDeals } from "../deals/dealsSheet";
import { toast } from "../toast";

/**
 * Short of gold (owner 2026-10-23: "if it says not enough gold it should link you to get more and take you to the page
 * to buy gold"): a small dialog saying how much more is needed, with GET GOLD — the Shop's Supplies tab, whose first
 * shelf is the gold packs (the free one first). `closing` is the sheet the tap came from, closed on the way so the Shop
 * opens like any home-tab screen. Off the hub (no Shop to open) it is only the line.
 */
export async function notEnoughGold(parent: HTMLElement, need: number, closing: Element | null = null): Promise<void> {
  const go = await confirmPurchase(parent, {
    title: "NOT ENOUGH GOLD", currency: null, price: "", confirm: "GET GOLD", shop: true,
    body: `<p class="supdlg">${goldIcon(40)}<span>You need <b>${fmtCompact(need)}</b> more gold.</span></p>`,
  });
  if (!go) return;
  closing?.remove();
  const shop = openShops(SUPPLIES_TAB);
  shop?.querySelector<HTMLElement>(".sscroll")?.scrollTo({ top: 0 });
}

/** The gold still missing for the next queued level of `target` (what queueUpgrade would charge, less what is held). */
export function queueGoldNeeded(p: PlayerProfile, target: UpgradeTarget, index: number): number {
  return Math.max(1, p.costFor(nextUpgradeLevel(p, target, index)) - p.gold);
}

/**
 * Short of gems (owner 2026-10-23: "and sure we've done the same for gems"): "Not enough gems · You need N more" with
 * GET GEMS — the Store on its Gems page. In the quiet after a loss (`nudge` false: the never list, ENGAGEMENT C) it
 * names the shortfall only, as before; without a Store (a build with none) the same.
 */
export async function notEnoughGems(parent: HTMLElement, need: number, closing: Element | null = null, nudge = true): Promise<void> {
  if (!nudge) { toast(parent, `You need ${fmtCompact(need)} more gems`); return; }
  const go = await confirmPurchase(parent, {
    title: "NOT ENOUGH GEMS", currency: null, price: "", confirm: "GET GEMS", shop: true,
    body: `<p class="supdlg">${gemIcon(40)}<span>You need <b>${fmtCompact(need)}</b> more gems.</span></p>`,
  });
  if (!go) return;
  closing?.remove();
  if (!openDeals({ page: "gems" })) toast(parent, "Gems come from stars, bosses and Orders");
}
